export default __webpack_public_path__ + "static/media/netflex.17196103.png";